import { render, staticRenderFns } from "./liveGoods.vue?vue&type=template&id=8cee6c18&"
import script from "./liveGoods.vue?vue&type=script&lang=js&"
export * from "./liveGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports